import { type FacetValueBase, WeightedColorsArray } from 'Models';
import { GET } from 'Modules/serverApi/common/httpClient';
import type { ServerModel } from 'Modules/serverApi/types';
import { isObjectRecord } from 'Utils/guards';

import ResponseValidationError from './common/responseValidationError';
import { isGenericItem } from './common/validators';
import { ITEM_ENDPOINT } from './endpoints';

export default async function item(key: string): Promise<ServerModel.SearchItem> {
  return await GET(ITEM_ENDPOINT, { key })
    .then((raw) => {
      const response = getGenericItem(raw);
      const { _Color: rawColor, ...rest } = response;
      const searchItem: ServerModel.SearchItem = { ...rest };
      const colors = getColorValues(rawColor);

      if (colors) {
        searchItem._Color = new WeightedColorsArray(colors);
      }

      return searchItem;
    })
    .catch((failure) => {
      const error = failure instanceof Error ? failure : new Error(String(failure));
      error.message = `Failed to get item by key ${key}: ${error.message}`;
      throw error;
    });
}

function getGenericItem(value: unknown): ServerModel.GenericItem {
  if (!isGenericItem(value)) {
    throw new ResponseValidationError(`${ITEM_ENDPOINT}: expected object payload`);
  }
  return value;
}

function getColorValues(value: unknown): string[] | FacetValueBase[] | undefined {
  if (!Array.isArray(value)) {
    return;
  }

  if (value.every((item) => typeof item === 'string')) {
    return value;
  }

  if (value.every(isFacetValueBase)) {
    return value;
  }
}

function isFacetValueBase(value: unknown): value is FacetValueBase {
  return isObjectRecord(value) && typeof value.field === 'string' && typeof value.term === 'string';
}
